/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_P1_AfterInputs */

const es_landing_law_p1_after = /** @type {(inputs: Landing_Law_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— pueden alquilarlas hasta tres meses al año. Antes era ilegal, ya no lo es.`)
};

const gl_landing_law_p1_after = /** @type {(inputs: Landing_Law_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— poden alugalas ata tres meses ao ano. Antes era ilegal; xa non o é.`)
};

const en_landing_law_p1_after = /** @type {(inputs: Landing_Law_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— can rent them out for up to three months a year. It used to be illegal; not anymore.`)
};

/**
* | output |
* | --- |
* | "— can rent them out for up to three months a year. It used to be illegal; not anymore." |
*
* @param {Landing_Law_P1_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_p1_after = /** @type {((inputs?: Landing_Law_P1_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_P1_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_p1_after(inputs)
	if (locale === "en") return en_landing_law_p1_after(inputs)
	return es_landing_law_p1_after(inputs)
});